import React from "react";
import { OverlapCreatorBox } from "../../components/ReportTemplate/components/OverlapCreatorBox/OverlapCreatorBox";

export const renderOverlapCreator = (data, GridBox) => {
  const key = data.label;

  return (
    <GridBox key={key} id={key}>
      <OverlapCreatorBox data={data} />
    </GridBox>
  );
};
